
import React from 'react';
import { X, Check, Building2, Shield } from 'lucide-react';
import { 
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow
} from "@/components/ui/table";

const CtoServiceAgencyComparison = () => {
  const comparisonItems = [
    {
      category: "Interessen",
      agency: "Agentur denkt an eigene Projekte",
      external: "Wir denken an dein Gesamt­budget"
    },
    {
      category: "Kosten­übersicht",
      agency: "Einzel­rechnungen",
      external: "Komplette Kosten auf einen Blick"
    },
    {
      category: "Kontrolle",
      agency: "Du musst nachfassen",
      external: "Unabhängiges Monitoring"
    },
    {
      category: "Risiko",
      agency: "Erst handeln, wenn es brennt",
      external: "Probleme erkennen, bevor sie teuer werden"
    },
    {
      category: "Anbieter­bindung",
      agency: "Hohe Abhängigkeit",
      external: "Jederzeit wechsel- und verhandlungs­stark"
    },
    {
      category: "Ergebnis",
      agency: "Schwierig zu messen",
      external: "Feste Ziele & messbare Resultate"
    },
    {
      category: "Dein Aufwand",
      agency: "Viel Abstimmung",
      external: "Mehr Zeit fürs Kerngeschäft"
    }
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Warum nicht einfach "nur" eine Agentur?</h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Kurz gesagt: Wenn du als Geschäfts­führer müde bist, einfach "blind zu vertrauen", bringt eine externe IT-Leitung Überblick, Kosten­kontrolle und bessere Resultate.
            </p>
          </div>
          
          <div className="bg-white rounded-xl shadow-md overflow-hidden">
            <div className="overflow-x-auto">
              <Table>
                <TableHeader>
                  <TableRow className="bg-blue-50">
                    <TableHead className="p-4 text-left border-b border-gray-200"></TableHead>
                    <TableHead className="p-4 text-left border-b border-gray-200 text-gray-700">
                      <div className="flex items-center">
                        <Building2 className="h-5 w-5 text-gray-500 mr-2" />
                        <span>Agentur ohne IT-Leitung</span>
                      </div>
                    </TableHead>
                    <TableHead className="p-4 text-left border-b border-gray-200 text-blue-700">
                      <div className="flex items-center">
                        <Shield className="h-5 w-5 text-blue-600 mr-2" />
                        <span>Externe IT-Leitung</span>
                      </div>
                    </TableHead>
                  </TableRow>
                </TableHeader>
                <TableBody>
                  {comparisonItems.map((item, index) => (
                    <TableRow key={index} className="border-b border-gray-100">
                      <TableCell className="p-4 font-medium text-gray-800">{item.category}</TableCell>
                      <TableCell className="p-4 text-gray-600">
                        <div className="flex items-center">
                          <X className="h-4 w-4 text-orange-500 flex-shrink-0 mr-2" />
                          <span>{item.agency}</span>
                        </div>
                      </TableCell>
                      <TableCell className="p-4 text-gray-700">
                        <div className="flex items-center">
                          <Check className="h-4 w-4 text-green-500 flex-shrink-0 mr-2" />
                          <span className="font-medium">{item.external}</span>
                        </div>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CtoServiceAgencyComparison;
